const prjphaseActionTypes = {
  SET_PRJPHASES: "SET_PRJPHASES",
};

export default prjphaseActionTypes;
